export default __webpack_public_path__ + "static/media/joetrader.d148ac99.svg";